<script>
import GenericResourcesView from "@/components/GenericResourcesView";
import bus from "@/bus";
import { useResourcesStore } from "../../stores/resources";

export default {
  setup() {
    const resourcesStore = useResourcesStore();
    return { resourcesStore };
  },
  components: {
    GenericResourcesView,
  },
  data() {
    return {
      buttons: [
        {
          id: "modify",
          label: "views.admin.commune_modify",
          color: "airbnbBlue",
        },
      ],
    };
  },
  computed: {
    users() {
      return this.resourcesStore.admin.data;
    },
  },
  created() {
    bus.on("modify", this.modify);
  },
  methods: {
    async modify({ idx }) {
      bus.emit("openModal", { modal: "modifyAdmin", params: this.users[idx] });
    },
  },
};
</script>

<template>
  <div>
    <header
      class="p-4 font-semibold bg-white text-gray-600 border-t-2 border-solid border-gray-300"
    >
      {{ $t("views.admin.admin_account") }}
    </header>
    <GenericResourcesView class="p-5" type="admin" :buttons="buttons" />
  </div>
</template>

